import { render } from "./DebtorPage.vue?vue&type=template&id=167a9424&scoped=true"
import script from "./DebtorPage.vue?vue&type=script&lang=js"
export * from "./DebtorPage.vue?vue&type=script&lang=js"

import "./DebtorPage.vue?vue&type=style&index=0&id=167a9424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167a9424"]])

export default __exports__